module.exports = __webpack_public_path__ + "img/s8_pen2.e7798179.png";